import catalog from './catalog'
import list from './list'
import create from './create'
import addSpaces from './addSpaces'
import removeSpaces from './removeSpaces'
import details from './details'
import remove from './remove'
import addEmployees from './addEmployees'
import removeEmployees from './removeEmployees'
import updateName from './updateName'
import updateColor from './updateColor'
import search from './search'
import employees from './employees'
import spaces from './spaces'
import updateWorkplaceGroupEmployees from '@api/workplaceGroup/updateEmployees'
import csv from './createExport'
import addDepartmentToWorkplaceGroup from './addDepartmentToWorkplaceGroup'
import removeSpacefromWpg from './removeSpacesfromWpg'
import removeWorkplaceGroupsFromSpaces from './removeWorkplaceGroupsFromSpaces'

export default {
  catalog,
  list,
  create,
  addSpaces,
  removeSpaces,
  details,
  remove,
  addEmployees,
  removeEmployees,
  updateName,
  updateColor,
  updateWorkplaceGroupEmployees,
  search,
  employees,
  spaces,
  csv,
  addDepartmentToWorkplaceGroup,
  removeSpacefromWpg,
  removeWorkplaceGroupsFromSpaces,
}
